import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {DropdownList} from '@components/common/dropdown-list/dropdown-list'
import {TwTitle} from './containers'
import LangIcon from './icons/icon-lang.svg'
import {useSystemAppearanceStore} from './system-appearance-store'

export const ChooseInterfaceLanguage = observer(() => {
  const [state, store] = useSystemAppearanceStore()
  return (
    <div className="flex flex-col">
      <TwTitle className="mb-16">
        <div className="flex mr-4 text-primary">
          <LangIcon />
        </div>
        {Lang.msg.profilePage.interfaceLanguage}:
      </TwTitle>
      <DropdownList
        className="ml-28 w-128"
        onChange={lang => store.changeLanguage(lang)}
        value={state.currentLanguage}
        options={Lang.getLanguages().map(lang => ({
          value: lang.langCode,
          label: lang.langName
        }))}
      />
    </div>
  )
})
